const KEY = 'passkey_enrolled';

// localStorage peut lever (mode privé, stockage désactivé) : jamais bloquant.
export function hasPasskeyFlag() {
  try {
    return window.localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function setPasskeyFlag() {
  try {
    window.localStorage.setItem(KEY, '1');
  } catch {
    /* ignoré */
  }
}

export function clearPasskeyFlag() {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    /* ignoré */
  }
}
